export default __webpack_public_path__ + "static/media/confusionImg_4.02593a93.webp";